export default __webpack_public_path__ + "static/media/IMG_20220724_203126.6be16951.jpg";